/**
 * Cuál ítem del menú se resalta cuando varias rutas calzan.
 *
 * ── DE DÓNDE SALE ──────────────────────────────────────────────────────────────────────────────
 * El founder, mirando la barra lateral: «¿por qué en el sidebar se seleccionan ambos?». «Catálogo»
 * vive en `/dropshipping` y «Billetera» en `/dropshipping/smartydrop/saldo`; el resaltado comparaba
 * por PREFIJO, así que estando en la Billetera se prendían las dos.
 *
 * 🪤 NO SE NOTABA ANTES, y por eso nadie lo escribió: la Billetera era HIJA del catálogo, y los
 *    hijos se resaltan por su cuenta. Al subirla a hermana, su ruta quedó colgando de la ruta de la
 *    otra — y el prefijo, que hasta ese día era inofensivo, empezó a mentir.
 *
 * ⭐ GANA EL MÁS ESPECÍFICO. Es la regla de cualquier router, y la única que no hay que volver a
 *    tocar cuando aparezca un cuarto ítem anidado. Excluir a mano a las hermanas conocidas
 *    funciona hoy y se rompe en silencio con la próxima.
 *
 * Vive acá, pura y sin React, porque una regla que se puede probar con tres strings no debería
 * necesitar montar la barra entera para saber si está bien.
 */

/**
 * ¿La ruta actual cae dentro de `url`?
 *
 * 🪤 EL LÍMITE ES EL SEGMENTO, no el carácter. Sin esto `/productos` calzaría con
 *    `/productos-eliminados`, que es otra pantalla — un falso positivo que sólo aparece el día que
 *    alguien crea la ruta parecida.
 */
export function laRutaCae(actual: string, url: string): boolean {
  if (url === '/') return actual === '/';
  return actual === url || actual.startsWith(`${url}/`);
}

/**
 * ¿`url` es el ítem que tiene que resaltarse, o hay otro que calza mejor?
 *
 * `todas` son las rutas de todos los ítems del menú; la más larga que calce es la que gana.
 */
export function ganaElMasEspecifico(actual: string, url: string, todas: readonly string[]): boolean {
  if (!laRutaCae(actual, url)) return false;
  return !todas.some((otra) => otra.length > url.length && laRutaCae(actual, otra));
}
